/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';
import { FileService } from '../../services/file.service';
import { Button } from '../ui/Button';

interface PdfViewerProps {
  fileId: string;
  title: string;
}

export const PdfViewer = ({ fileId, title }: PdfViewerProps) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

  useEffect(() => {
    if (!fileId) return;

    let objectUrl: string;

    FileService.getPdfByFileId(fileId)
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        setPdfBlob(blob);
        objectUrl = URL.createObjectURL(blob);
        setPdfUrl((prev) => {
          if (prev) URL.revokeObjectURL(prev);
          return objectUrl;
        });
      })
      .catch((err) => {
        console.error('Failed to load PDF:', err);
      });

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  const handleDownload = () => {
    if (!pdfBlob) return;
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleOpenInTab = () => {
    if (!pdfUrl) return;

    const win = window.open('', '_blank');
    if (!win) return;

    win.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
              overflow: hidden;
            }
            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>
        <body>
          <iframe src="${pdfUrl}"></iframe>
        </body>
      </html>
    `);
    win.document.close();
  };

  return (
    <div>
      <div className="w-full h-[500px] flex items-center justify-center bg-white border rounded-lg shadow overflow-hidden ">
        {pdfUrl ? (
          <>
            <iframe src={pdfUrl} title="PDF Viewer" className="w-full h-full " />
          </>
        ) : (
          <p className="text-xl font-semibold text-primary">Loading PDF...</p>
        )}
      </div>
      <div className="flex justify-end gap-2 mt-5">
        <Button variant="primary" className="px-7 sm:px-10" onClick={handleDownload}>
          Download
        </Button>
        <Button variant="secondary" className="px-7 sm:px-10" onClick={handleOpenInTab}>
          Open in Tab
        </Button>
      </div>
    </div>
  );
};
